import { useCallback } from 'react'
import { UserRole, MembershipLevel } from 'types/graphql'
import { useCurrentUser } from 'modules/auth/useCurrentUser'

export type Thing = 'writeReviews' | 'flagReviews' | 'accessMember' | 'accessAdmin' | 'becomeFriend' | 'signUp'

export const useCan = () => {
  const { user, sessionIsInitialized } = useCurrentUser()

  const membershipLevel = user?.membershipLevel
  const currentUserRole = user?.role
  const loggedIn = sessionIsInitialized && !!user

  const can = useCallback(
    (thing: Thing) => {
      switch (thing) {
        case 'becomeFriend':
          return membershipLevel !== MembershipLevel.Friend

        case 'accessMember':
          return loggedIn && currentUserRole !== UserRole.None

        case 'accessAdmin':
          return loggedIn && currentUserRole === UserRole.Admin

        case 'signUp':
          return sessionIsInitialized && !loggedIn

        case 'writeReviews':
          return loggedIn

        case 'flagReviews':
          /* Disable flagging of reviews until we know what it means */
          return false
        default:
          return false
      }
    },
    [sessionIsInitialized, currentUserRole, loggedIn, membershipLevel]
  )

  return { can }
}
